import React from 'react';
import { ExternalChip } from '../../lib/types';
import { useToast } from '../../components/Toast/ToastContext';
import Modal, { ModalTitle, ModalSubtitle, ModalActions } from '../../components/Modal/Modal';
import ConfirmSummary from '../../components/ConfirmSummary/ConfirmSummary';
import Button from '../../components/Button/Button';

interface ClaimChipModalProps {
  open: boolean;
  onClose: () => void;
  chip: ExternalChip | null;
  onClaim: (chip: ExternalChip) => void;
}

export default function ClaimChipModal({ open, onClose, chip, onClaim }: ClaimChipModalProps) {
  const { showToast } = useToast();

  if (!chip) return null;

  function handleConfirm() {
    onClaim(chip!);
    showToast(`Chip ${chip!.id} added to your organization`);
    onClose();
  }

  return (
    <Modal open={open} onClose={onClose}>
      <ModalTitle>Add to My Organization</ModalTitle>
      <ModalSubtitle>
        This will transfer the chip to your organization. Pet information will be preserved. The current owner will be
        removed.
      </ModalSubtitle>

      <ConfirmSummary
        sections={[
          {
            title: 'Chip',
            fields: [
              { label: 'Chip ID', value: chip.id },
              { label: 'Pet', value: chip.petName },
              { label: 'Current Owner', value: chip.ownerName || 'No owner' },
            ],
          },
        ]}
      />

      <ModalActions>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="green" onClick={handleConfirm}>
          Confirm
        </Button>
      </ModalActions>
    </Modal>
  );
}
